export const consoleLog = console.log